"use strict";

define('rs/form/formobjects/textbox/textbox.formobject.view',['rs/form/formobjects/base.formobject.view', 'jquery-elastic'], function (BaseFormObjectView) {
  var TextBoxFormObjectView = BaseFormObjectView.extend({
    templates: {
      'textbox.formobject': 'renderFormControls'
    },
    events: {
      'blur >.form-object-contents textarea': 'handleTextboxBlur',
      'focus >.form-object-contents textarea': 'handleTextboxFocus'
    },
    renderFormObjectControls: function renderFormObjectControls(templateProperties) {
      return this.renderFormControls(templateProperties);
    },
    setupFormElement: function setupFormElement() {
      var input = this.getContentElement().find('textarea');
      this.setFormElement(input);
      if (!this.isDesignerMode()) {
        _.defer(function () {
          input.elastic();
        });
      }
    },
    getValue: function getValue() {
      return this.getFormElement().val();
    },
    handleTextboxBlur: function handleTextboxBlur(ev) {
      this.getDelegate().requestValueChange();
    },
    handleTextboxFocus: function handleTextboxFocus(ev) {
      this.getDelegate().testSet().ignore();
    }
  });
  return TextBoxFormObjectView;
});

